import { createAuthAxios, handleApiError } from "../../utils/apiUtils";
import { API_BASE_URL } from "../../config/apiConfig";

/**
 * Room Statistics & Preview Service
 * Handles all preview and stats-related API calls for research rooms
 */
class RoomStatsService {
  /**
   * Get full room preview with ALL stats
   * Use this for the full preview page
   * @param {String} roomId - The room ID
   */
  async getFullPreview(roomId) {
    try {
      if (!roomId) {
        throw new Error("Room ID is required");
      }
      const authAxios = createAuthAxios();
      const response = await authAxios.get(
        `${API_BASE_URL}/research-rooms/${roomId}/preview`
      );
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  }

  /**
   * Get compact preview for room cards/lists
   * Lighter version with essential stats only
   * @param {String} roomId - The room ID
   */
  async getCompactPreview(roomId) {
    try {
      if (!roomId) {
        throw new Error("Room ID is required");
      }
      const authAxios = createAuthAxios();
      const response = await authAxios.get(
        `${API_BASE_URL}/research-rooms/${roomId}/preview/compact`
      );
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  }

  /**
   * Get activity stats (messages, trends)
   * @param {String} roomId - The room ID
   */
  async getActivityStats(roomId) {
    try {
      if (!roomId) {
        throw new Error("Room ID is required");
      }
      const authAxios = createAuthAxios();
      const response = await authAxios.get(
        `${API_BASE_URL}/research-rooms/${roomId}/stats/activity`
      );
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  }

  /**
   * Get task analytics
   * @param {String} roomId - The room ID
   */
  async getTaskStats(roomId) {
    try {
      if (!roomId) {
        throw new Error("Room ID is required");
      }
      const authAxios = createAuthAxios();
      const response = await authAxios.get(
        `${API_BASE_URL}/research-rooms/${roomId}/stats/tasks`
      );
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  }

  /**
   * Get member engagement stats
   * @param {String} roomId - The room ID
   */
  async getEngagementStats(roomId) {
    try {
      if (!roomId) {
        throw new Error("Room ID is required");
      }
      const authAxios = createAuthAxios();
      const response = await authAxios.get(
        `${API_BASE_URL}/research-rooms/${roomId}/stats/engagement`
      );
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  }

  /**
   * Get room health score
   * @param {String} roomId - The room ID
   */
  async getHealthScore(roomId) {
    try {
      if (!roomId) {
        throw new Error("Room ID is required");
      }
      const authAxios = createAuthAxios();
      const response = await authAxios.get(
        `${API_BASE_URL}/research-rooms/${roomId}/stats/health`
      );
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  }

  /**
   * Force refresh stats cache
   * @param {String} roomId - The room ID
   */
  async refreshStats(roomId) {
    try {
      if (!roomId) {
        throw new Error("Room ID is required");
      }
      const authAxios = createAuthAxios();
      const response = await authAxios.post(
        `${API_BASE_URL}/research-rooms/${roomId}/stats/refresh`
      );
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  }
}

const roomStatsService = new RoomStatsService();
export default roomStatsService;













